import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { eOrderStatusType } from '../../enums';

@Injectable({
  providedIn: 'root'
})
export class ResponseBodyPropertyMappingInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(map(event => {
      if (event instanceof HttpResponse && 
        event.headers.get('content-type')?.at(0)?.toLocaleLowerCase() === 'application/json') {
        let modifiedBody;

        if (Array.isArray(event.body)) {
          modifiedBody = [...event.body];
          modifiedBody.forEach(item => {
            if (item.orderStatusTypeID) {
              item.orderStatusTypeID = this.map(item.orderStatusTypeID);
            }
          });
        } else {
          modifiedBody = { ...event.body };
          if (modifiedBody.orderStatusTypeID) {
            modifiedBody.orderStatusTypeID = this.map(modifiedBody.orderStatusTypeID);
          }
        }

        return modifiedBody ? event.clone({ body: modifiedBody }) : event;
      } else {
        return event;
      }
    }));
  }
  
  private map(status: eOrderStatusType): string {
    switch (status) {
      case eOrderStatusType.exception:
      case eOrderStatusType.failedAutomation:
      case eOrderStatusType.manualFulfillment:
      case eOrderStatusType.staged:
      case eOrderStatusType.documentReProcessing:
      case eOrderStatusType.documentProcessing:
      case eOrderStatusType.requestedAtRegistry:
        return eOrderStatusType.pending;

      default:
        return status;
    }
  }
}